<template>
    <v-container>
        <div v-if="$route.name === 'Available Projects'">
            <center-project-component :projects="projects" :language="language" :available="available"/>
        </div>
        <div v-else v-for="triads in counter" :key="triads">
            <left-project-component v-if="triads % 2 != 0 " :projects="filterProjects(triads)" :language="language" :available="available"/>
            <rightproject-component v-if="triads % 2 == 0 " :projects="filterProjects(triads)" :language="language" :available="available"/>  
        </div>
    </v-container>
</template>

<script>

    import restApi from "@/rest-api"
    import LeftProjectComponent from './LeftProjectComponent.vue'
    import RightprojectComponent from './RightprojectComponent.vue'
    import CenterProjectComponent from './CenterProjectComponent.vue'

    export default {
    components: { LeftProjectComponent, RightprojectComponent, CenterProjectComponent },
        props :{
            fetch: Boolean,
            language: String
        },
        data() {
            return {
                counter: 4,
                projects: [],
                filters: {},
                available: false
            }
        },
        created() {
            this.filters = this.$store.getters.getFilters
            this.fetchProjects()
            
        },
        watch: {
            fetch() {
                if(this.fetch){
                    this.fetchProjects()
                }
            },
           '$route.name': {
                handler(value) {
                    if(value === 'Available Projects') {
                        this.available = true
                        this.fetchProjects()
                    }
                }
           }
        },
        methods: {
            fetchProjects() {
                var search =''
                if(this.$route.path=='/Projects/All/Old'){
                    if(this.language!='Ελληνικά') {
                        search = `/project/filtered?type=old&&lang=en`
                    } else {
                        search = `/project/filtered?type=old`
                    }
                } else {
                    if(this.language!='Ελληνικά') {
                        search = `/project/filtered?lang=en`
                    } else {
                        search = `/project/filtered`
                    }
                }
                restApi
                .post(search, this.filters.filters)
                .then(response => {
                    this.projects = this.available ? response.data.filter(element => element.available) : response.data
                    this.projects.sort(this.compare)
                    this.counter = Math.ceil(this.projects.length / 3)
                    setTimeout(() => {
                        this.$emit("setFetch")
                    }, 500)
                })
                .catch((error) => {
                    console.log(error);
                });
            },
            goToProject() {
                this.$router.push({name: 'Project'});
            },
            filterProjects(triads) {
                var start= 0;
                var end= 0;
                if (triads==1) {
                    start=0;
                    end=triads*3;
                } else {
                    end = triads*3;
                    start = end-3;
                }
                return this.projects.slice(start, end);
            },
            compare(a, b) {
                // Use toUpperCase() to ignore character casing
                const yearA = a.year;
                const yearB = b.year;

                let comparison = 0;
                if (yearA > yearB) {
                    comparison = -1;
                } else if (yearA < yearB) {
                    comparison = 1;
                }
                return comparison;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        position: relative;
    }

    .grayscale{
        filter: grayscale(100%);
    }

    .grayscale:hover {
        transition: 0.3s ease-in-out; 
        filter: grayscale(0%);
    }
</style>